let TireReviews = (() => {
    const __pageSize = 10; // pagination page size

    const init = () => {
        const store = Util.getCookie("store_location");
        const queryParams = new URLSearchParams(location.search);
        const sku = queryParams.get('sku');

        const getTireReviews = jQuery.ajax({
            url: `${Util.lambdaHost}/reviews/tires?sku=${sku}`,
            type: 'GET',
            headers: {
                'x-api-key': Util.lambdaApiKey
            }
        });

        const getTireDetails = jQuery.ajax({
            url: `${Util.lambdaHost}/tires/detail?store=${store}&sku=${sku}`,
            type: 'GET',
            headers: {
                'x-api-key': Util.lambdaApiKey
            }
        });

        jQuery.when(getTireReviews, getTireDetails).done((tireReviews, tireDetails) => {
            tireReviews = tireReviews[0];
            tireDetails = tireDetails[0];
            const ratingInfo = Util.getReviewCount(tireReviews);

            jQuery('#tire-detail-make-logo')
                .attr('src', `${Util.s3ImageUrl}Tire_Brand_Images_Cropped/TireBrand_Logo_${tireDetails['TireMake'].replace(/ /g, "+")}.png`)
                .attr('alt', `${tireDetails['TireMake']}`)
                .attr('title', `${tireDetails['TireMake']}`)

            const updatedTireBrand = tireDetails['TireMake'].replace(' ', '-');

            const updatedTireModel = tireDetails['TireModel']
                .replace(/®/g, "<sup>®</sup>")
                .replace(/©/g, "<sup>©</sup>")
                .replace(/™/g, "<sup>™</sup>");

            jQuery('#tire-detail-model').html(updatedTireModel);
            jQuery('#tire-detail-type').html(tireDetails['TireType']);
            jQuery('.spec-value').eq(0).html(tireDetails['TireWarranty']);
            jQuery('.spec-value').eq(1).html(tireDetails['TireLoadRange']);
            jQuery('.spec-value').eq(2).html(tireDetails['TireSpeedRating']);
            jQuery('.spec-value').eq(3).html(tireDetails['TireSideWall']);
            jQuery('.spec-value').eq(4).html(tireDetails['TireRunFlat']);
            jQuery('.spec-value').eq(5).html(tireDetails['TireUTQG']);
            jQuery('.spec-value').eq(6).html(tireDetails['TireSKUNumber']);

            jQuery('#reviews-section-tire-detail-review-wrapper').html(() => {
                let html = '';
                if (ratingInfo['ReviewCount'] !== 0) {
                    html += `<span class="tire-detail-rating">${Util.lookupStarRating(ratingInfo['Rating'])}</span>`
                }
                html += `<a href="#">(${ratingInfo['ReviewCount']} Reviews)</a>`;
                return html;
            })

            if (ratingInfo['ReviewCount'] !== 0) {
                jQuery('.header-reviews-info').html(`
                    <ul>
                        <li> Tread Wear <b>${Math.round(ratingInfo['TreadWearRating'] * 10) / 10}/5</b> </li>
                        <li> Traction <b>${Math.round(ratingInfo['TractionRating'] * 10) / 10}/5</b> </li>
                        <li> Comfort <b>${Math.round(ratingInfo['ComfortRating'] * 10) / 10}/5</b> </li>
                        <li> Value <b>${Math.round(ratingInfo['ValueRating'] * 10) / 10}/5</b> </li>
                    </ul>`);
                jQuery('#tire-detail-reviews-wrapper').append(`
                    <div class="reviews-view-all-row-heading">
                        <p> LATEST REVIEWS </p> 
                        <a href="/tire-search/detail?sku=${sku}&tirebrand=${updatedTireBrand}" class="monro-button monro-button-yellow preview-quote back-to-detail">
                            BACK TO TIRE DETAILS
                        </a>
                        <div class="showing-pagination">Showing <div id="results-shown"></div> of <div id="total-results"></div> Results</div>
                    </div>
                    <div class="tire-detail-review">
                        <!-- Populate reviews with JS !-->
                    </div>
                    <div class="tire-search-results-container">
                        <div class="results-container">
                            <div class="results-body">
                                <div id="pagination-container" class="results-body-footer"></div>
                            </div>
                        </div>
                    </div>`);
            }
            __paginationInit(tireReviews);
        });
    }

/**
     * Paginates the results using paginationjs, documentation here: http://pagination.js.org/docs/index.html
     */
    const __paginationInit = (tireReviews) => {
        jQuery('#pagination-container').pagination({
            dataSource: tireReviews,
            pageSize: __pageSize,
            prevText: 'previous',
            nextText: 'next',
            callback: function (data, pagination) {
                __populateReviewResult(data);

                if (tireReviews.length <= 0) {
                    jQuery('#results-shown').text("0");
                    jQuery('#total-results').text("0");
                    return;
                } else {
                    let displayString = '0';
                    if (pagination.pageNumber === 1 && pagination.totalNumber > 0) {
                        if (pagination.totalNumber <= pagination.pageSize) {
                            displayString = '1 - ' + pagination.totalNumber;
                        } else {
                            displayString = '1 - ' + (pagination.pageSize);
                        }
                    } else if (pagination.totalNumber > 0) {
                        const startNum = (pagination.pageNumber - 1) * pagination.pageSize + 1;
                        const endNum = startNum + pagination.pageSize - 1;
                        displayString = startNum + ' - ' + Math.min(endNum, pagination.totalNumber);
                    }

                    jQuery('#results-shown').text(displayString);
                    jQuery('#total-results').text(pagination.totalNumber);
                }
            },
            afterNextOnClick: function () {
                Util.scrollToTop();
            },
            afterPreviousOnClick: function () {
                Util.scrollToTop();
            }
        });
    }

    const __populateReviewResult = (reviewArr) => {
        var reviewResult = reviewArr.reduce((accumulator, {
            Comment,
            DateReviewed,
            ReviewerName,
            TireRating,
            WouldPurchaseAgain,
            TreadWearRating,
            TractionRating,
            ComfortRating,
            ValueRating
        }) => {
            return accumulator += `
                <div class="detail-review-block">
                    <span class="tire-detail-rating"> ${Util.lookupStarRating(TireRating)}</span>
                    <p class="review-date"> ${DateReviewed.substr(0, DateReviewed.indexOf(' '))} ${ReviewerName ? ' BY ' + ReviewerName : ''}</p>
                    <p class="review-text">
                        ${Comment}
                        </br></br>
                    Would you recommend this product? <b>${WouldPurchaseAgain}</b>
                    </p>
                    <div class="review-details">
                    <ul>
                        ${TreadWearRating ? '<li> Tread Wear <b>'+Util.tireReviewMapping(TreadWearRating)+'/5</b></li>': ''}
                        ${TractionRating ? '<li> Traction <b>'+Util.tireReviewMapping(TractionRating)+'/5</b></li>': ''}
                        ${ComfortRating ? '<li> Comfort <b>'+Util.tireReviewMapping(ComfortRating)+'/5</b></li>': ''}
                        ${ValueRating ? '<li> Value <b>'+Util.tireReviewMapping(ValueRating)+'/5</b></li>': ''}
                    </ul>  
                </div>
                </div>
            `;
        }, '');

        jQuery('.tire-detail-review').html(reviewResult);
    }

    return {
        init: init,
    }
})();